import { render, staticRenderFns } from "./UpgradeAccount.vue?vue&type=template&id=1f90374e&scoped=true"
import script from "./UpgradeAccount.vue?vue&type=script&lang=js"
export * from "./UpgradeAccount.vue?vue&type=script&lang=js"
import style0 from "./UpgradeAccount.vue?vue&type=style&index=0&id=1f90374e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f90374e",
  null
  
)

export default component.exports